import { render, staticRenderFns } from "./CancelExchangeTruck.vue?vue&type=template&id=64b6fa92&scoped=true"
import script from "./CancelExchangeTruck.vue?vue&type=script&lang=js"
export * from "./CancelExchangeTruck.vue?vue&type=script&lang=js"
import style0 from "./CancelExchangeTruck.vue?vue&type=style&index=0&id=64b6fa92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b6fa92",
  null
  
)

export default component.exports